import { Cake, Heart, Briefcase, Star, PartyPopper, MessageSquare } from 'lucide-react';
import { Input } from '@verlo/shared/components/ui/input';
import { OptionChips } from '@verlo/shared/components/ui/segmented';

// What a table is celebrating. Set on the seat sheet, and from the order screen afterwards:
// "it's her birthday" is as often said with the menus as at the door.
export const OCCASIONS = [
  { value: 'birthday', label: 'Birthday', Icon: Cake },
  { value: 'anniversary', label: 'Anniversary', Icon: Heart },
  { value: 'business', label: 'Business', Icon: Briefcase },
  { value: 'date_night', label: 'Date night', Icon: Heart },
  { value: 'celebration', label: 'Celebration', Icon: PartyPopper },
  { value: 'vip', label: 'VIP', Icon: Star },
  { value: 'other', label: 'Other', Icon: MessageSquare },
];

/** The occasion as it reads on the floor, or null for none. */
export function occasionWords(table) {
  const o = table?.occasion;
  if (!o || o === 'none') return null;
  if (o === 'other') return (table.occasion_notes || '').trim() || 'Occasion';
  return OCCASIONS.find((x) => x.value === o)?.label || o.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}

export const occasionIcon = (occasion) => OCCASIONS.find((x) => x.value === occasion)?.Icon || Star;

/** Chips for the occasion; tapping the chosen one again clears it. */
export default function OccasionPicker({ occasion = '', notes = '', onChange }) {
  return (
    <div className="space-y-2" data-testid="occasion-picker">
      <OptionChips
        value={occasion}
        onChange={(v) => onChange({ occasion: v === occasion ? '' : v, notes: v === 'other' ? notes : '' })}
        options={OCCASIONS.map((o) => ({ value: o.value, label: o.label, testId: `occasion-${o.value}` }))}
        chipClassName="h-10"
      />
      {occasion === 'other' && (
        <Input
          autoFocus
          placeholder="What are they celebrating?"
          value={notes}
          onChange={(e) => onChange({ occasion, notes: e.target.value })}
          data-testid="occasion-notes-input"
        />
      )}
    </div>
  );
}
